export const LOCAL_STORAGE_IS_DESKTOP_FILTERS_WERE_APPLIED = 'isDesktopFiltersWereApplied';

export const updateLocalStorageFiltersWereApplied = () => {
  try {
    let value;
    const existing = localStorage.getItem(LOCAL_STORAGE_IS_DESKTOP_FILTERS_WERE_APPLIED);

    if (existing) {
      const filtersValue = JSON.parse(existing);

      //проверяет что фильтры были применены 2 раза
      if (filtersValue.isSecondClick) {
        return;
      }

      value = { ...filtersValue, isSecondClick: true };
    } else {
      //запоминаем дату первого клика
      value = { date: Date.now(), isShown: false, isSecondClick: false };
    }

    localStorage.setItem(LOCAL_STORAGE_IS_DESKTOP_FILTERS_WERE_APPLIED, JSON.stringify(value));
  } catch (er) {
    console.error('Error working with localStorage', er);
  }
};
